import { useEffect, useRef } from 'react';

const useRunOnce = (callback) => {
    const isRun = useRef(false);
    useEffect(() => {
        if (!isRun.current) {
            callback();
            isRun.current = true;
        }
    }, [isRun, callback]);
};

export default useRunOnce;
